var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import FileTransferApi from '~/api/file-transfer';
import GetFileUrlApi from '~/api/get-file-url';
import { useWebsocket } from '~/providers/websocket';
import convertB64StringToByteArray from '~/utils/convertB64StringToByteArray';
import { getDocument } from './queries';
const DocumentViewContext = createContext({});
const DocumentViewProvider = (props) => {
    const ws = useWebsocket();
    const { id } = useParams();
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [document, setDocument] = useState(null);
    useEffect(() => {
        const fetchDocument = (fileId) => __awaiter(void 0, void 0, void 0, function* () {
            if (!fileId) {
                return;
            }
            setIsDocumentLoading(true);
            const document = yield getDocument(fileId, ws);
            const fileTransferInfo = yield GetFileUrlApi.getUrlById(id);
            const jsonBlob = yield FileTransferApi.get(fileTransferInfo.fileTransferUrl);
            if (!jsonBlob)
                return;
            const text = yield jsonBlob.text();
            const byteCharacters = atob(yield JSON.parse(text).data);
            const byteArray = yield convertB64StringToByteArray(byteCharacters);
            document.blob = new Blob([byteArray], { type: 'application/pdf' });
            if (document === null || document === void 0 ? void 0 : document.clauses) {
                document.clauses.forEach(clause => {
                    clause.id = uuidv4();
                });
            }
            setDocument(document);
            setIsDocumentLoading(false);
        });
        fetchDocument(id);
    }, [id]);
    const value = {
        isDocumentLoading,
        document,
    };
    return React.createElement(DocumentViewContext.Provider, Object.assign({ value: value }, props));
};
const useDocumentView = () => {
    const context = useContext(DocumentViewContext);
    if (!context) {
        throw new Error('IDocumentViewContext must be used inside of a DocumentViewProvider');
    }
    return context;
};
export { DocumentViewProvider, useDocumentView, };
